import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homefour-software-integrations',
  templateUrl: './homefour-software-integrations.component.html',
  styleUrls: ['./homefour-software-integrations.component.scss']
})
export class HomefourSoftwareIntegrationsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
